import { render } from "./NeuronPopulationTable.vue?vue&type=template&id=47bd993d&scoped=true"
import script from "./NeuronPopulationTable.vue?vue&type=script&lang=js"
export * from "./NeuronPopulationTable.vue?vue&type=script&lang=js"

import "./NeuronPopulationTable.vue?vue&type=style&index=0&id=47bd993d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bd993d"]])

export default __exports__